$(function () {
    const $header = $('.page-header'),
        $headerHeight = $header.outerHeight(),
        $disordersMainImg = $('.js-anchors-main-img');

    if (window.matchMedia("(min-width: 768px)").matches) {

        const disordersItems = document.querySelectorAll('.js-anchors-item');

        function checkDisordersVisibility() {
            const viewportTop = window.scrollY + $headerHeight;

            const backgroundImageUrl = $disordersMainImg.css('background-image').match(/url\((['"])?(https?:)?\/\/(.+?)\1\)/)[3],
                imageName = backgroundImageUrl.split('/').pop();

            for (let i = 0; i < disordersItems.length; i++) {
                const node = disordersItems[i];
                const rect = node.getBoundingClientRect();
                const nodeTop = rect.top + window.scrollY;
                if ((nodeTop >= viewportTop && nodeTop <= viewportTop + 100)) {
                    const dataImgValue = node.getAttribute('data-img'),
                        dataImgName = dataImgValue.split('/').pop();

                    if (dataImgName !== imageName) {
                        $disordersMainImg.fadeOut(300, function () {
                            $disordersMainImg.css({'background-image': `url(${dataImgValue})`});
                            $disordersMainImg.fadeIn(300);
                        });
                    } else {
                        $disordersMainImg.css({'background-image': `url(${dataImgValue})`});
                    }
                }
            }
        }

        if (disordersItems.length) {
            window.addEventListener('scroll', checkDisordersVisibility);
        }

    }
});